import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Notification } from 'base-ui'

import { useProductPageContext } from '../productPageContext'
import { ProductPageOdsDialogHeader } from '../ProductPageOdsDialog/ProductPageOdsDialogHeader'
import { ProductPageOdsDialogMainInfoSection } from '../ProductPageOdsDialog/ProductPageOdsDialogMainInfoSection'
import {
  ProductPageOdsDialogOnlineDoctorSection,
  ProductPageOdsDialogOnlineDoctorSectionNotice,
  ProductPageOdsDialogOnlineDoctorSectionSteps,
} from '../ProductPageOdsDialog/ProductPageOdsDialogOnlineDoctorSection'
import { ProductPageOdsDialogServiceLinkButton } from '../ProductPageOdsDialog/ProductPageOdsDialogServiceLinkButton'

export const ProductPageOdsDialogContent: FC = () => {
  const { productPageOdsConfig } = useProductPageContext()
  const i18n = useIntl()

  if (!productPageOdsConfig) {
    return null
  }

  return (
    <>
      <ProductPageOdsDialogHeader
        title={<FormattedMessage id="pdp.buyboxwithvariants.odsModal.header" />}
      >
        <ProductPageOdsDialogMainInfoSection />
        <ProductPageOdsDialogServiceLinkButton
          href={productPageOdsConfig.odsLandingPageForProduct}
        />
      </ProductPageOdsDialogHeader>

      <div className="mt-10">
        <ProductPageOdsDialogOnlineDoctorSection className="rounded-2xl bg-light-primary-low px-5 py-6">
          <ProductPageOdsDialogOnlineDoctorSectionSteps />
          <Notification
            className="mb-3 mt-8 border border-dark-primary-min"
            severity="info"
            title={i18n.formatMessage({
              id: 'pdp.buyboxwithvariants.odsModal.tabs.tab1.coverageTitle',
            })}
            variant="secondary"
          >
            <FormattedMessage id="pdp.buyboxwithvariants.odsModal.tabs.tab1.coverageMessage" />
          </Notification>
          <ProductPageOdsDialogOnlineDoctorSectionNotice />
        </ProductPageOdsDialogOnlineDoctorSection>
      </div>
    </>
  )
}
